module.exports = __webpack_public_path__ + "static/media/bonus4@2x.9c6f2389.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/bonus4@2x.png
// module id = 1767
// module chunks = 0